export const formatDateHourFromTimestamp = (timestamp) => {
  const date = new Date(timestamp)
  return new Intl.DateTimeFormat(`pt-BR`, {
    weekday: `long`,
    year: `numeric`,
    month: `long`,
    day: `numeric`,
    hour: `numeric`,
    minute: `numeric`,
  }).format(date)
}

export const formatDateFromTimestamp = (timestamp, withTime = false) => {
  if (!timestamp) return
  const date = new Date(timestamp)
  return new Intl.DateTimeFormat(`pt-BR`, {
    day: `numeric`,
    month: `numeric`,
    year: `numeric`,
    hour: withTime ? `2-digit` : undefined,
    minute: withTime ? `2-digit` : undefined,
    second: withTime ? `2-digit` : undefined,
  }).format(date)
}

export const formatDateFromTimestampToInput = (timestamp) => {
  if (!timestamp || timestamp === `null`) return

  const [date] = new Date(timestamp).toISOString().split(`T`)

  return date
}

export const formatDateFromInputToApiQueryString = (value) => {
  if (!value) return

  const [YYYY, MM, DD] = value.split(`-`)

  return `${DD}-${MM}-${YYYY}`
}

export const formatDateFromOcrToInput = (value) => {
  if (!value) return

  const [DD, MM, YYYY] = value.split(`/`)

  return `${YYYY}-${MM}-${DD}`
}

export const niceDate = (date, withHour = false) => {
  if (!date) return date
  const d = new Date(date)
  return (
    (withHour && d.toLocaleString(`pt-BR`).substr(0, 16)) ||
    d.toLocaleDateString(`pt-BR`)
  )
}

export const localeISO = (withTime = true, date = new Date()) => {
  const timezone = date.getTimezoneOffset() * 60 * 1000
  return new Date(date - timezone).toISOString().slice(0, withTime ? 19 : 10)
}
